var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          attrs: { small: "", outlined: "", color: "primary" },
          on: {
            click: function ($event) {
              _vm.dialog = true
            },
          },
        },
        [
          _c("v-icon", { staticClass: "mr-2", attrs: { small: "" } }, [
            _vm._v("mdi-layers-plus"),
          ]),
          _vm._v("Add map layer "),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Add map layer")]),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: { label: "Layer name", dense: "" },
                    model: {
                      value: _vm.layerName,
                      callback: function ($$v) {
                        _vm.layerName = $$v
                      },
                      expression: "layerName",
                    },
                  }),
                  _c("v-file-input", {
                    attrs: {
                      label: "CSV file",
                      accept: ".csv,text/csv",
                      dense: "",
                    },
                    on: {
                      change: function ($event) {
                        _vm.error = null
                      },
                    },
                    model: {
                      value: _vm.file,
                      callback: function ($$v) {
                        _vm.file = $$v
                      },
                      expression: "file",
                    },
                  }),
                  _vm.error
                    ? _c(
                        "v-alert",
                        { attrs: { type: "error", outlined: "", dense: "" } },
                        [_vm._v(_vm._s(_vm.error))]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        color: "primary",
                        disabled: !_vm.file,
                      },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("Add")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }